<template>
    <div class="stores-list">
        <div
            v-for="store in stores"
            :key="store.street"
            class="stores-list__item"
        >
            <h2>
                {{ lang.stores.logo }}
            </h2>

            <div class="stores-list__icons" @click="$router.push('/stores')" style="cursor: pointer;">
                <svg-icon icon="location-icon"/>

                <span>{{ store.street }}</span>
            </div>

            <div class="stores-list__icons" style="cursor: pointer;">
                <svg-icon icon="phone-icon"/>

                <a :href="`tel:+359${store.phone}`" v-html="store.phone"></a>
            </div>

            <div class="stores-list__icons">
                <svg-icon icon="clock-icon"/>

                <span>{{ store.openingHours }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'

export default {
    name: 'StoresList',
    components: {
        SvgIcon,
    },
    computed: {
        lang() {
            return this.$parent.lang
        },
        stores() {
            return [
                {
                    street: this.lang.stores.street.cherni,
                    phone: '089 704 9777',
                    openingHours: this.lang.openingHours,
                },
                {
                    street: this.lang.stores.street.hristo,
                    phone: '089 911 1386',
                    openingHours: this.lang.openingHours,
                },
                {
                    street: this.lang.stores.street.zlatovrah,
                    phone: '089 915 6444',
                    openingHours: this.lang.openingHours,
                },
            ]
        },
    },
}
</script>

<style lang="scss">
.stores-list {
    &__item {
        margin-bottom: 24px;

        svg {
            margin-right: 12px;
        }
    }

    &__icons {
        margin-bottom: 6px;
    }
}
</style>
